"use client"

import { ExternalLink } from "lucide-react"
import { cn } from "@/lib/utils"
import { toAbsoluteUrlHref, toDisplayUrl } from "@/lib/url-display"

export function FullUrlLink({
  url,
  className,
}: {
  url: string | null | undefined
  className?: string
}) {
  const display = toDisplayUrl(url)
  if (!display) {
    return <span className={cn("text-muted-foreground text-xs", className)}>—</span>
  }
  const href = toAbsoluteUrlHref(url)
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={cn("text-blue-600 hover:underline text-xs inline-flex items-center gap-1 min-w-0 max-w-full", className)}
    >
      <span className="break-all min-w-0">{display}</span>
      <ExternalLink className="w-3 h-3 shrink-0" aria-hidden />
    </a>
  )
}

export function ConnectionLinkInformationCell({
  targetUrl,
  anchor,
  className,
}: {
  targetUrl: string | null | undefined
  anchor: string | null | undefined
  className?: string
}) {
  const anchorTrim = anchor != null ? String(anchor).trim() : ""
  const hasAnchor = anchorTrim !== "" && anchorTrim !== "—"
  return (
    <div className={cn("space-y-2 min-w-0 max-w-md", className)}>
      <div className="min-w-0">
        <div className="text-[10px] font-medium text-muted-foreground tracking-wide mb-0.5">Target</div>
        <FullUrlLink url={targetUrl} />
      </div>
      <div className="min-w-0">
        <div className="text-[10px] font-medium text-muted-foreground tracking-wide mb-0.5">Anchor</div>
        {hasAnchor ? (
          <span className="text-xs text-foreground break-words">{anchorTrim}</span>
        ) : (
          <span className="text-muted-foreground text-xs">—</span>
        )}
      </div>
    </div>
  )
}
